/** @file Exact element-wise equality of two number lists (the W2-31 no-op test of mesh commands). */

/** True when both are undefined, or both hold the same numbers in the same order. */
export function sameNumbers(a: readonly number[] | undefined, b: readonly number[] | undefined): boolean {
  if (a === undefined || b === undefined) return a === b;
  return a.length === b.length && a.every((v, i) => v === b[i]);
}
